import { FC, useMemo } from 'react';
import { Link as RouterLink } from 'react-router-dom';

import { Box, Button, Container, Typography } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

const NotFound: FC = () => {
  const theme = useTheme();
  const mobileDevice = useMediaQuery(theme.breakpoints.down('sm'));
  const { t, i18n } = useTranslation();

  const zoordinatesTranslation = useMemo(() => {
    switch (i18n.language) {
      case 'sv':
      case 'nb':
        return 'Zoordinater';
      case 'en':
      default:
        return 'Zoordinates';
    }
  }, [i18n.language]);

  return (
    <>
      <Helmet>
        <title>{t('Error: Not Found')}</title>
      </Helmet>
      <Box
        sx={{
          alignItems: 'center',
          backgroundColor: 'background.paper',
          display: 'flex',
          minHeight: '100%',
          px: 3,
          py: '80px',
        }}
      >
        <Container maxWidth="lg">
          <Typography
            align="center"
            color="textPrimary"
            variant={mobileDevice ? 'h4' : 'h1'}
          >
            {`404: ${t('The page you are looking for isn’t here')}`}
          </Typography>
          <Typography
            align="center"
            color="textSecondary"
            sx={{ mt: 0.5 }}
            variant="subtitle2"
          >
            {`${t('Maybe you do not have the required')} ${zoordinatesTranslation} ${t('to access this route?')}`}
          </Typography>
          <Typography
            align="center"
            color="textSecondary"
            sx={{ mt: 0.5 }}
            variant="subtitle2"
          >
            {t('You either tried some shady route or you came here by mistake. Whichever it is, try using the navigation.')}
          </Typography>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6,
            }}
          >
            <Box
              alt="Under development"
              component="img"
              src={`/static/error/error404_${theme.palette.mode}.svg`}
              sx={{
                height: 'auto',
                maxWidth: '100%',
                width: 400,
              }}
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              mt: 6,
            }}
          >
            <Button
              color="primary"
              component={RouterLink}
              to="/"
              variant="outlined"
            >
              {t('Back to Home')}
            </Button>
          </Box>
        </Container>
      </Box>
    </>
  );
};

export default NotFound;
